import * as filestack from 'filestack-js'
import config from 'lib/config'

class FilestackClient {
  constructor({getPolicy}) {
    this.getPolicy = getPolicy
    this.client = filestack.init(config.FILESTACK_KEY)
  }

  async getDefaultPolicy() {
    if (!this.defaultPolicy) {
      this.defaultPolicy = await this.getPolicy({call: ['store', 'pick', 'read']})
    }
    return this.defaultPolicy
  }

  async storeFile(file, progress, options = {}) {
    const policy = await this.getDefaultPolicy()
    return this.client.upload(
      file,
      {
        ...options,
        onProgress: (event) => progress(event.totalPercent),
      },
      {},
      {},
      policy,
    )
  }

  async removeFile(file) {
    const handle = file.handle
    const policy = await this.getPolicy({call: ['remove'], handle})
    return this.client.remove(handle, policy)
  }
}

export default FilestackClient
